import { ToastService } from '@iamsoftware/react-hooks';
import { Service } from './Service';

export class CommonService extends Service {

  static entity: string = 'iam-common';

  static getPartyTypes(): Promise<any> {
    return this.axios.get(`${this.entity}/party-types`).then(res => res.data);
  }

  static getProvinces(): Promise<any> {
    return this.axios.get(`${this.entity}/geos/provinces`).then(res => res.data);
  }

  static getCounties(stateProvinceGeoId: string): Promise<any> {
    return this.axios.get(`${this.entity}/geos/${stateProvinceGeoId}/assocs?toGeoTypeEnumId=GEOT_WARD`).then(res => res.data);
  }

  static getPseudoIdFormat(): Promise<any> {
    return this.axios.get(`${this.entity}/agreement-pseudo-id-format`).then(res => res.data);
  }

  static amountToWords(amount): Promise<any> {
    return this.axios.get(`${this.entity}/amount-to-words?amount=${amount}`).then(res => res.data);
  }
  static verificationType(): Promise<any> {
    return this.axios.get(`${this.entity}/verification-type`).then(res => res.data);
  }
  static agreementRoleTypes(): Promise<any> {
    return this.axios.get(`${this.entity}/agreement-role-types`).then(res => res.data);
  }

  static getPartyByTax(partyTaxId: any): Promise<any> {
    return this.axios.get(`iam-party/info/by-tax-code?partyTaxId=${partyTaxId}`).then(res => res.data);
  }

  static getDownloadToolsLink(architecture?: '32bit' | '64bit'): Promise<any> {
    const params = architecture ? { architecture } : {};
    return this.axios.get(`${this.entity}/download-tools-link`, { params }).then(res => res.data);
  }

  static getDocumentTypes(): Promise<any> {
    return this.axios.get(`${this.entity}/oauth2/google/google-doc/document-types`).then(res => res.data);
  }

  static generateDocumentCode(documentType: string): Promise<any> {
    return this.axios.get(`${this.entity}/document/code`, { params: { documentType } }).then(res => res.data);
  }

  static getAgreementType(): Promise<any> {
    return this.axios.get(`${this.entity}/agreement-types`).then(res => res.data);
  }
  static getFileTypes(): Promise<any> {
    return this.axios.get(`${this.entity}/file-types`).then(res => res.data);
  }

  private static lastH: string | null = null;
  // Sử dụng path đại diện để Nginx Proxy xử lý (vượt CORS và Secure Cookie)
  private static DKKD_BASE_URL = '/dkkd-api';

  static async getPartyFromDKKDAutomated(taxCode: string): Promise<any> {
    console.log('--- Tra cứu DKKD cho MST:', taxCode);
    try {
      if (this.lastH) {
        try {
          const result = await this.finalDKKDRequest(taxCode, this.lastH);
          if (result && Array.isArray(result)) return result;
        } catch (e) {
        }
      }

      // Bắt đầu trực tiếp từ trang online để bớt redirect 302
      await this.dkkdStepCall(`${this.DKKD_BASE_URL}/online/default.aspx`);
      await this.dkkdStepCall(`${this.DKKD_BASE_URL}/auth/Public/LogOn.aspx?ReturnUrl=%2fonline%2fdefault.aspx`);

      const htmlContent = await this.dkkdStepCall(`${this.DKKD_BASE_URL}/inf/default.aspx?search=${taxCode}&customsearch=1`, true);
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, 'text/html');
      const input = doc.getElementById('ctl00_hdParameter') as HTMLInputElement;
      this.lastH = input ? input.value : null;

      console.log('--- CommonService: Đã lấy được mã h mới:', this.lastH);
      if (!this.lastH) throw new Error('Không lấy được hdParameter');

      return await this.finalDKKDRequest(taxCode, this.lastH);
    } catch (error) {
      console.error('--- CommonService DKKD Error:', error);
      throw error;
    }
  }

  private static async dkkdStepCall(url: string, returnText: boolean = false): Promise<string> {
    console.log('--- CommonService: DKKD Calling:', url);
    const response = await fetch(url, { method: 'GET', credentials: 'include' });
    if (!response.ok) throw new Error(`Step failed: ${url}`);
    return returnText ? await response.text() : '';
  }

  private static async finalDKKDRequest(taxCode: string, h: string): Promise<any> {
    console.log('--- CommonService: DKKD Final Search Request...');
    const url = `${this.DKKD_BASE_URL}/inf/Public/Srv.aspx/GetSearch`;
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Accept': 'application/json, text/javascript, */*; q=0.01',
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ searchField: taxCode, h: h })
    });
    if (!response.ok) throw new Error('Final request failed');
    const result = await response.json();
    return result.d;
  }
}
